import axios from 'axios'
import apiConfig from '../../config/apiConfig'
import { buildURL } from '../helper'
import { getBpIdParam } from '../../common/helper'
import { trackFeatureAction } from '../../common/otel'

const updateFeedbackSurvey = async (requestObject: any) => {
  const bpIdParam = getBpIdParam()
  trackFeatureAction('feedback_survey_update', 'attempt')
  try {
    const { data } = await axios.put(
      `${buildURL('feedbackSurveyResponse', apiConfig.feedback)}${bpIdParam}`,
      requestObject,
    )
    trackFeatureAction('feedback_survey_update', 'success')
    return data
  } catch (error) {
    trackFeatureAction('feedback_survey_update', 'error')
    throw error
  }
}

export default updateFeedbackSurvey
